import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Toast
} from 'reactstrap';
import { FaAngleDoubleLeft, FaClipboardList, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBoxes, FaBuilding, FaCalendarAlt, FaCartPlus, FaCheck, FaCheckCircle, FaClock, FaEdit, FaEnvelope, FaExclamationTriangle, FaHistory, FaIdCard, FaImage, FaInfoCircle, FaList, FaListAlt, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPhone, FaPlus, FaPrint, FaReceipt, FaSearch, FaShoppingCart, FaStore, FaTh, FaTimes, FaTrash, FaUser, FaUserCheck, FaUserSecret, FaWhatsapp, FaKeyboard, FaGift, FaGlobe } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import { saleActions } from "../../sagas/saleSlice";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../helpers/config";
import amiriNormal from '../../assets/fonts/Amiri-Regular.ttf';
import { clientActions } from "../../sagas/clientSlice";
import ClientForm from "../Client/ClientForm";
import Select from 'react-select/async';
import { components } from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { deliveryActions } from "../../sagas/deliveryNoteSlice";
import { formatPrice } from "../../helpers/utility";
import VirtualKeyboard from '../Common/VirtualKeyboard';


const initialValues = {
  numero: '',
  commandeId: null,
  commandeNumero: '',
  commandeDateCreation: new Date().toISOString(),
  clientId: null,
  clientNom: '',
  clientAdresse: '',
  clientIce: '',
  clientTelephone1: '',
  clientTelephone2: '',
  clientEmail: '',
  lignes: [],
  status: 'EN_PREPARATION',
  isClientParticulier: false,
};

const validationSchema = Yup.object({
  clientId: Yup.number().nullable(),
  dateLivraison: Yup.date().required('Date de livraison requise'),
});

const couleurOptions = [
  { value: 'ROUGE', label: 'Rouge', color: '#FF0000' },
  { value: 'VERT', label: 'Vert', color: '#00FF00' },
  { value: 'BLEU', label: 'Bleu', color: '#0000FF' },
  { value: 'JAUNE', label: 'Jaune', color: '#FFFF00' },
  { value: 'ORANGE', label: 'Orange', color: '#FFA500' },
  { value: 'VIOLET', label: 'Violet', color: '#8A2BE2' },
  { value: 'NOIR', label: 'Noir', color: '#000000' },
  { value: 'BLANC', label: 'Blanc', color: '#FFFFFF' },
  { value: 'GRIS', label: 'Gris', color: '#808080' },
  { value: 'MARRON', label: 'Marron', color: '#A52A2A' },
  { value: 'CYAN', label: 'Cyan', color: '#00FFFF' },
  { value: 'MAGENTA', label: 'Magenta', color: '#FF00FF' }
];

const SaleForm = () => {
  const montantTotalTTC = useSelector(state => state.sales?.montantTotalTTC || 0);
  const montantTotalHT = useSelector(state => state.sales?.montantTotalHT || 0);
  const montantTotalTaxe = useSelector(state => state.sales?.montantTotalTaxe || 0);

  const [cachedOptions, setCachedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [editedBL, setEditedBL] = useState(null);
  const [isPassager, setIsPassager] = useState(false);
  const [estCadeau, setEstCadeau] = useState(false);
  const [estOnline, setEstOnline] = useState(false);
  const cart = useSelector(state => state.sales?.cart || []);
  const [cartPage, setCartPage] = useState(1);

  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { businessName, email, address, telephone } = useSelector(state => state.auth);
  const [displayMode, setDisplayMode] = useState('card'); // or 'card'
  const [showClientModal, setShowClientModal] = useState(false);

  const villesMaroc = [
    'Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger',
    'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan',
    'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'
  ];

  let { id } = useParams();

  const [client, setClient] = useState({
    nom: '',
    prenom: '',
    cin: '',
    telephone1: '',
    telephone2: '',
    email: '',
    adresse: '',
    ville: 'Casablanca',
    typeClient: 'PARTICULIER',
    codePostal: '',
    plafond: 0,
    entreprise: '', // New field for "Entreprise"
    ice: '',// New field for "ICE",
    active: true,
    solde: 0 // Ce champ sera en lecture seule
  });
  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    products,
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
  const { list } = useSelector((state) => state.deliveryNotes);
  const clients = useSelector(state => state.clients.clients);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const searchInputRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showClientForm, setShowClientForm] = useState(false);
  const [isValidatingOrder, setIsValidatingOrder] = useState(false);
  const [showVirtualKeyboard, setShowVirtualKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState('text');
  const [keyboardTarget, setKeyboardTarget] = useState(null);
  const [currentEditingIndex, setCurrentEditingIndex] = useState(null);
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);
  const [clientErrors, setClientErrors] = useState({});
  const role = useSelector((state) => state.auth.role);
  const isCaissier = role === 'ROLE_CAISSIER';

  const toggleClientModal = () => {
    setClientModal(!clientModal);
    setShowClientForm(false); // Reset form visibility when modal is toggled
    loadClientOptions(''); // Load clients when modal opens
  }

  // Virtual Keyboard Functions
  const openVirtualKeyboard = (target, mode = 'text', editingIndex = null) => {
    setKeyboardTarget(target);
    setKeyboardMode(mode);
    setCurrentEditingIndex(editingIndex);
    setShowVirtualKeyboard(true);
  };

  const closeVirtualKeyboard = () => {
    setShowVirtualKeyboard(false);
    setKeyboardTarget(null);
    setCurrentEditingIndex(null);
  };

  // Add new state
  const cartItemsPerPage = 20;

  // Calculate cart pagination
  const cartStartIndex = (cartPage - 1) * cartItemsPerPage;
  const cartEndIndex = cartStartIndex + cartItemsPerPage;
  const currentCartItems = cart.slice(cartStartIndex, cartEndIndex);

  const togglePaymentModal = () => {
    setPaymentModal(!paymentModal);
    if (paymentModal) {
      setIsValidatingOrder(false);
    }
  };

  useEffect(() => {
    // Fetch supplier options when the component mounts
    loadClientOptions('');
    dispatch(productActions.findAllUnites());

  }, []);

  useEffect(() => {
    if (id) {
      dispatch(saleActions.clearCart());
      setCartPage(1); // Reset cart page
      let bl = list.find(b => b.id == id);
      console.log(bl);
      setEditedBL(bl);
      setEstCadeau(bl.estCadeau);
      setEstOnline(bl.estOnline);
      dispatch(saleActions.setCart(bl));

      // Set selected client if editing and client exists
      if (bl && bl.clientId) {
        // Find client in the clients list
        const client = clients.find(c => c.id === bl.clientId);
        if (client) {
          const clientOption = {
            value: client.id,
            label: client.typeClient === 'PARTICULIER'
              ? `${client.code ? client.code + ' - ' : ''}${client.nom} ${client.prenom}`
              : `${client.code ? client.code + ' - ' : ''}${client.entreprise}`,
            client
          };
          setSelectedClient(clientOption);
        }
      } else {
        setIsPassager(true);
      }
    }
  }, [id, clients]);

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(productActions.findAll({
      search: "",
      page: currentPage - 1,
      size: pageSize,
    }));
  }, [currentPage]);

  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [products]);


  const handleClientAdded = (newClient) => {
    loadClientOptions("");
    setSelectedClient(newClient);
    setShowClientForm(false);
    toggleClientModal();
  };

  const loadClientOptions = async (inputValue) => {
    return new Promise((resolve) => {
      dispatch(clientActions.search({
        query: inputValue,
        onSuccess: (data) => {
          console.log(data);
          const options = data.content.map(client => {
            let label = '';
            if (client.typeClient === 'PARTICULIER') {
              label = (client.code ? client.code + ' - ' : '') + client.nom + ' ' + client.prenom;
            } else {
              label = (client.code ? client.code + ' - ' : '') + client.entreprise;
            }
            return {
              value: client.id,
              label,
              client
            };
          });
          setCachedOptions(options); // Cache the options
          resolve(options);
        }
      }));
    });
  };

  const handleAddToCart = (product) => {
    dispatch(saleActions.addToCart(product));
  };

  const handleSelectClient = (client) => {
    setSelectedClient(client);
    toggleClientModal();
  };

  const handleInputChange = useCallback((index, event) => {
    const { name, value } = event.target;
    dispatch(saleActions.handleInputChange({ index, name, value }));
  }, [dispatch]);


  const handleRemoveFromCart = useCallback((productId) => {
    console.log(productId)
    dispatch(saleActions.removeFromCart(productId));
    setCartPage((prevPage) => {
      // Calculate new cart length after removal
      const newCartLength = cart.length - 1;
      const newTotalPages = Math.ceil(newCartLength / cartItemsPerPage);

      // If previous page is out of range, move to last valid page (at least 1)
      return prevPage > newTotalPages ? Math.max(1, newTotalPages) : prevPage;
    });
  }, [cart, cartItemsPerPage, dispatch]);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(productActions.findAll({
        search: query,
        page: currentPage - 1,
        size: pageSize,
      }));
    }, 1000), // Wait 500ms after last keystroke
    []
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmitClient = (e) => {
    e.preventDefault();

    const newErrors = {};
    // Common validations
    if (!client.telephone1) newErrors.telephone1 = 'Téléphone obligatoire';
    if (!client.adresse) newErrors.adresse = 'Adresse obligatoire';

    // Validations for "PARTICULIER"
    if (client.typeClient === 'PARTICULIER') {
      if (!client.nom) newErrors.nom = 'Nom obligatoire';
      if (!client.prenom) newErrors.prenom = 'Prénom obligatoire';
    }

    // Validations for "ENTREPRISE"
    if (client.typeClient === 'ENTREPRISE') {
      if (!client.entreprise) newErrors.entreprise = 'Nom de l\'entreprise obligatoire';
      if (!client.ice) newErrors.ice = 'Numéro ICE obligatoire';
    }


    if (Object.keys(newErrors).length > 0) {
      setClientErrors(newErrors);
      return;
    }

    let payload = {
      data: {
        ...client,
        chantiers: [],
      },

      onSuccess: () => {

        Swal.fire({
          icon: 'success',
          title: 'Succès',
          text: 'Client enregistrés avec succès!',
          confirmButtonText: 'OK',
        });

        setTimeout(() => {
          // Réinitialisation du formulaire après succès
          setClient({
            nom: '',
            prenom: '',
            cin: '',
            telephone1: '',
            telephone2: '',
            typeClient: 'PARTICULIER',
            email: '',
            adresse: '',
            ville: 'Casablanca',
            codePostal: '',
            plafond: 0,
            entreprise: '',
            ice: '',
            solde: 0,
            active: true,
          });

          // Fermeture du modal
          setShowClientModal(false);
        }, 2000);
      },
    };

    dispatch(clientActions.addClient(payload));

  }



  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saleActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };


  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      dispatch(productActions.findAll({
        search: searchTerm,
        page: currentPage - 1,
        size: pageSize,
      }));
    }
  };

  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );

  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '550px',
        overflowY: 'auto'
      }}>
        <Table bordered hover>
          <thead>
            <tr>
              <th>{t('product.code')}</th>
              <th style={{ width: 250 }}>{t('product.description')}</th>
              <th>{t('product.salePrice')}</th>
            </tr>
          </thead>
          <tbody>
            {!products || (products ?? []).length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : ((products ?? []).map((product) => (
              <tr key={product.id} onClick={() => handleAddToCart(product)}>
                <td>{product.code}</td>
                <td>
                  {product.categorieLibelle} - {product.libelle}
                </td>
                <td className="align-middle text-end">
                  {formatPrice(product.prixVenteTTC1, false)} / {unites.find(u => u.code == product.unite).libelle}
                </td>
              </tr>
            ))
            )}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>
      </div>
    </>
  );

  const CardView = () => (
    <div style={{ height: '600px', overflowY: 'auto', padding: '0.25rem' }}>
      <Row xs={2} md={3} lg={3} className="g-2">
        {(!products || products.length === 0) && (
          <Col xs={12} className="text-center py-4">
            <div className="text-muted">
              <FaImage size={32} className="mb-2 opacity-50" />
              <p className="mb-0 small">{t('product.noProducts')}</p>
            </div>
          </Col>
        )}
        {products.map(product => (
          <Col key={product.id}>
            <Card

              onClick={() => handleAddToCart(product)}
              style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderRadius: '8px',
                minHeight: '220px' // Slightly increased to accommodate colors
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.12)';
                e.currentTarget.style.borderColor = '#0d6efd';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.05)';
              }}
            >
              {/* Subtle hover indicator - only on image area */}
              <div
                className="position-absolute d-flex align-items-center justify-content-center text-white opacity-0 product-hover-indicator"
                style={{
                  top: '0',
                  left: '0',
                  right: '0',
                  height: '100px', // Only cover the image area
                  background: 'rgba(13, 110, 253, 0.15)',
                  backdropFilter: 'blur(1px)',
                  transition: 'opacity 0.2s ease',
                  borderRadius: '8px 8px 0 0',
                  zIndex: 5
                }}
              >
                <div className="text-center">
                  <FaCartPlus size={16} className="text-primary bg-white rounded-circle p-1" style={{ width: '28px', height: '28px' }} />
                </div>
              </div>

              {/* Compact image container */}
              <div
                className="position-relative overflow-hidden"
                style={{
                  height: '100px',
                  borderRadius: '8px 8px 0 0'
                }}
              >
                {product.photo ? (
                  <img
                    src={`${config.baseURL}${product.photo}`}
                    alt={product.libelle}
                    className="w-100 h-100"
                    style={{
                      objectFit: 'cover',
                      transition: 'transform 0.2s ease'
                    }}
                  />
                ) : (
                  <div
                    className="w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                    }}
                  >
                    <FaImage size={24} className="text-muted opacity-50" />
                  </div>
                )}

                {/* Compact stock badge */}
                {product.stock !== undefined && (
                  <Badge
                    color={product.stock > 10 ? 'success' : product.stock > 0 ? 'warning' : 'danger'}
                    className="position-absolute top-0 end-0 m-1"
                    style={{ fontSize: '0.6rem', padding: '0.2rem 0.4rem', zIndex: 6 }}
                  >
                    {product.stock > 0 ? product.stock : '0'}
                  </Badge>
                )}
              </div>

              {/* Compact card body */}
              <CardBody className="p-2 d-flex flex-column">
                {/* Product code - smaller */}
                {product.code && (
                  <div className="mb-1">
                    <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                      {product.code}
                    </small>
                  </div>
                )}

                {/* Compact product title */}
                <div
                  className="product-title-compact mb-1 fw-semibold text-dark lh-sm"
                  style={{
                    fontSize: '0.75rem',
                    minHeight: '2.25rem',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}
                  title={product.libelle}
                >
                  {product.categorieLibelle} -{product.libelle}
                </div>

                {/* Colors display */}
                {product.couleurs && product.couleurs.length > 0 && (
                  <div className="colors-display-sales mb-1">
                    <div className="d-flex flex-wrap align-items-center gap-1">
                      {product.couleurs.slice(0, 5).map((couleur, index) => {
                        const couleurOption = couleurOptions.find(c => c.value === couleur);
                        return (
                          <span
                            key={`${product.id}-${couleur}-${index}`}
                            className="color-dot-sales"
                            style={{
                              backgroundColor: couleurOption?.color || '#6c757d',
                              border: couleurOption?.color === '#FFFFFF' ? '1px solid #dee2e6' : '1px solid rgba(0,0,0,0.1)'
                            }}
                            title={couleurOption?.label || couleur}
                          ></span>
                        );
                      })}
                      {product.couleurs.length > 5 && (
                        <span className="color-more-sales">
                          +{product.couleurs.length - 5}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* Genre badge */}
                {product.genre && (
                  <div className="mb-1">
                    <Badge
                      color={product.genre === 'HOMME' ? 'primary' : 'pink'}
                      style={{ fontSize: '0.6rem', padding: '0.2rem 0.4rem' }}
                    >
                      {t(`product.${product.genre.toLowerCase()}`)}
                    </Badge>
                  </div>
                )}

                {/* Compact price section */}
                <div className="mt-auto">
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="flex-grow-1">
                      <div
                        className="fw-bold text-primary"
                        style={{ fontSize: '0.8rem', lineHeight: '1' }}
                      >
                        {formatPrice(product.prixVenteTTC1)}  / {unites.find(u => u.code === product.unite)?.libelle || product.unite}
                      </div>
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '0.6rem', lineHeight: '1' }}
                      >

                      </small>
                    </div>

                    {/* Compact add button */}
                    <Button
                      color="primary"
                      size="sm"
                      className="rounded-circle p-0 border-0 ms-1"
                      style={{
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.7rem'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCart(product);
                      }}
                    >
                      <FaPlus size={8} />
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Updated styles */}
      <style jsx>{`
      .product-card-compact:hover .product-hover-indicator {
        opacity: 1 !important;
      }
      
      .product-card-compact {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
      }
      
      .product-title-compact {
        word-break: break-word;
        color: #2c3e50;
      }
      
      .colors-display-sales {
        min-height: 16px;
      }
      
      .color-dot-sales {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        display: inline-block;
        cursor: pointer;
        transition: transform 0.1s ease;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }
      
      .color-dot-sales:hover {
        transform: scale(1.3);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }
      
      .color-more-sales {
        font-size: 0.6rem;
        color: #6c757d;
        font-weight: 500;
        margin-left: 2px;
      }
      
      @media (max-width: 768px) {
        .product-card-compact {
          min-height: 200px;
        }
        
        .product-hover-indicator {
          height: 80px !important;
        }
        
        .color-dot-sales {
          width: 10px;
          height: 10px;
        }
      }
      
      @media (max-width: 576px) {
        .product-card-compact {
          min-height: 180px;
        }
        
        .product-hover-indicator {
          height: 70px !important;
        }
        
        .color-dot-sales {
          width: 8px;
          height: 8px;
        }
        
        .color-more-sales {
          font-size: 0.55rem;
        }
      }
    `}</style>
    </div>
  );


  const handleCreateSale = (values) => {
    if (!selectedClient && !isPassager) {
      Swal.fire({
        icon: 'warning',
        title: t('facture.clientRequired'),
        text: t('facture.clientRequiredMessage')
      });
      return;
    }

    const saleData = {
      clientId: isPassager ? null : selectedClient.value,
      isComptoir: true,
      isPassager: isPassager,
      estCadeau: estCadeau,
      estOnline: estOnline,
      status: editedBL ? editedBL.status : 'EN_PREPARATION',
      lignes: cart.map(item => ({
        articleId: item.articleId,
        articleCode: item.articleCode,
        articleNom: item.articleNom,
        quantiteLivree: item.quantite,
        unite: unites.find(u => u.code === item.unite).libelle,
        prixUnitaireTTC: item.prixUnitaireTTC,
        prixUnitaireHT: item.prixUnitaireHT,
        montantHT: item.montantHT,
        montantTTC: item.montantTTC,
        tauxTVA: item.tauxTVA
      })),
      montantTotalHT: montantTotalHT,
      montantTotalTTC: montantTotalTTC,
      montantTotalTaxe: montantTotalTaxe,
    };

    let payload = {
      id: id,
      data: saleData,
      onSuccess: (data) => {
        Swal.fire({
          icon: 'success',
          title: t('common.saved'),
          text: t('bonLivraison.savedSuccess'),
        });

        setReceiptData(data);
        setModal(true);
        dispatch(saleActions.clearCart());
        setPaymentModal(false);
        setIsValidatingOrder(false);
      },
      onError: (error) => {
        Swal.fire({
          icon: 'error',
          title: t('sale.error'),
          text: error.message || t('sale.errorMessage')
        });
      }
    };

    if (id) {
      dispatch(deliveryActions.update(payload));
    } else {
      dispatch(deliveryActions.add(payload));
    }
  };


  const handleCreateClient = () => {
    setShowClientModal(true);
  };

  const handleSelectedClient = (selectedOption) => {
    setSelectedClient(selectedOption);
    setShowClientModal(false);
  }

  const handleClientChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({
      ...prev,
      [name]: name === 'active' ? value === 'true' : value, // Convert "true"/"false" to boolean for the active field
    }));
  };

  // Add formik hook
  const formik = useFormik({
    initialValues: id ? editedBL : initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleCreateSale(values);
    }
  });

  const generatePreparationTicket = async () => {
    // You can either modify the existing downloadBill function or create a new one
    // for preparation tickets if your backend supports it
    handleDownloadPreparationTicket(receiptData);
  };

  const handleDownloadPreparationTicket = (commande) => {
    try {
      // Create PDF with 80mm thermal printer dimensions
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 200] // 80mm width, dynamic height
      });

      doc.setFont('helvetica');

      let yPosition = 5;
      const pageWidth = 80;
      const margin = 3;
      const contentWidth = pageWidth - (margin * 2);

      // Header - larger for 80mm
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text(businessName || 'MatjarPos', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 6;

      doc.setFontSize(12);
      doc.text('BON DE PREPARATION', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 6;

      // Indicate if sale is online
      if (receiptData?.estOnline) {
        doc.setFontSize(10);
        doc.setTextColor(0, 102, 204); // blue
        doc.text('VENTE EN LIGNE', pageWidth / 2, yPosition, { align: 'center' });
        doc.setTextColor(0, 0, 0); // reset to black
        yPosition += 5;
      }

      // Separator
      doc.setLineWidth(0.2);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      // Order info in two columns
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text('No:', margin, yPosition);
      doc.text('Date:', pageWidth / 2, yPosition);

      doc.setFont('helvetica', 'normal');
      doc.text(receiptData?.numero || '---', margin + 12, yPosition);
      const currentDate = receiptData?.createdAt;
      doc.text(currentDate, pageWidth / 2 + 15, yPosition);
      yPosition += 5;

      doc.setFont('helvetica', 'bold');
      doc.text('Prepare par:', pageWidth / 2, yPosition);
      doc.text(receiptData?.createdBy || '---', pageWidth / 2 + 25, yPosition);
      yPosition += 6;

      // Customer
      if (receiptData?.clientNom) {
        doc.setFont('helvetica', 'bold');
        doc.text('Client:', margin, yPosition);
        doc.setFont('helvetica', 'normal');
        doc.text(receiptData.clientNom.substring(0, 35), margin + 15, yPosition);
        yPosition += 5;
      }

      // Items section
      doc.setLineWidth(0.2);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 4;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text('ARTICLES A PREPARER', pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 5;

      // Table header
      doc.setFontSize(8);
      doc.text('Article', margin, yPosition);
      doc.text('Qte', pageWidth - 20, yPosition);
      yPosition += 3;

      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 3;

      // Items
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);

      receiptData?.lignes?.forEach((item, index) => {
        if (yPosition > 240) {
          doc.addPage([80, 200]);
          yPosition = 5;
        }

        // Item name (truncated if too long)
        const itemName = item.articleNom.length > 35 ? item.articleNom.substring(0, 32) + '...' : item.articleNom;
        doc.text(itemName, margin, yPosition);

        // Quantity
        doc.text(`${item.quantiteLivree} ${unites.find(u => item.unite === u.code)?.libelle}`, pageWidth - 20, yPosition);

        yPosition += 4;

        // Item code on next line (smaller)
        doc.setFontSize(6);
        doc.text(`Code: ${item.articleCode}`, margin + 2, yPosition);
        yPosition += 3;

        doc.setFontSize(8);
        yPosition += 1;
      });

      yPosition += 2;
      doc.setLineWidth(0.1);
      doc.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 5;

      const totalProducts = receiptData?.lignes?.length || 0;

      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text(`Nombre d'articles: ${totalProducts}`, margin + 2, yPosition);

      //const fileName = `preparation_${receiptData?.numero || 'ticket'}_${new Date().getTime()}.pdf`;
      //doc.save(fileName);

      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);

    } catch (error) {
      console.error("Error generating 80mm preparation ticket:", error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Erreur lors de la génération du bon de préparation 80mm'
      });
    }
  };

  console.log(currentCartItems)
  return (
    <Container fluid>
      {/* Edit Mode Header - Show when editing existing BL */}
      {id && editedBL && (
        <Row className="mb-3">
          <Col>
            <Card className="border-primary">
              <CardBody className="py-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <FaEdit className="text-primary me-2" size={20} />
                    <div>
                      <h6 className="mb-1 text-primary fw-bold">
                        Commande N° {editedBL.numero}
                      </h6>
                      <div className="d-flex align-items-center gap-3 text-muted">
                        <small>
                          <FaUser className="me-1" />
                          Client: <span className="fw-semibold">{editedBL.clientNom || 'Client passager'}</span>
                        </small>
                        <small>
                          <FaCalendarAlt className="me-1" />
                          Date: <span className="fw-semibold">{editedBL.createdAt}</span>
                        </small>
                        <small>
                          <FaInfoCircle className="me-1" />
                          Statut: <Badge
                            color={
                              editedBL.status === 'LIVRE' ? 'success' :
                                editedBL.status === 'EN_PREPARATION' ? 'warning' :
                                  editedBL.status === 'ANNULE' ? 'danger' : 'info'
                            }
                            className="ms-1"
                          >
                            {editedBL.status}
                          </Badge>
                        </small>
                      </div>
                    </div>
                  </div>
                  {/* <div className="d-flex align-items-center gap-2">
                    <Button
                      color="outline-secondary"
                      size="sm"
                      onClick={() => generatePreparationTicket()}
                    >
                      <FaTimes className="me-1" size={12} />
                      Imprimer
                    </Button>
                  </div>} */}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      <Row>
        {/* Product List */}
        <Col md={6} className="pe-4">
          <Card className="shadow-sm h-100">
            <CardBody>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (<>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Search Input - Left Side */}
                  <div className="position-relative flex-grow-1 me-3">
                    <Input
                      innerRef={searchInputRef}
                      type="text"
                      placeholder={t('product.searchFocusHint')}
                      value={searchTerm.toUpperCase()}
                      onKeyDown={handleSearchKeyDown}
                      onChange={handleSearchChange}
                      className={`ps-4 pe-16 ${isSearching ? 'searching' : ''}`}
                      title={t('product.searchShortcut')}
                    />
                    <FaSearch
                      style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#adb5bd'
                      }}
                      size={14}
                    />
                    <div className="d-flex position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', gap: '5px' }}>
                      <FaKeyboard
                        style={{
                          color: showVirtualKeyboard && keyboardTarget === 'search' ? '#007bff' : '#adb5bd',
                          cursor: 'pointer'
                        }}
                        size={16}
                        title="Clavier virtuel"
                        onClick={() => openVirtualKeyboard('search', 'text')}
                      />
                      <FaBarcode
                        style={{
                          color: '#adb5bd',
                          cursor: 'pointer'
                        }}
                        size={20}
                        title={t('product.scanHint')}
                      />
                    </div>
                  </div>
                  {/* <Button
                    color="primary"
                    size="sm"
                    className="d-flex align-items-center"
                    onClick={() => navigate('/sales/history')}
                    title={t('sale.viewHistory')}
                  >
                    <FaHistory className="me-2" />
                    {t('sale.viewHistory')}
                  </Button> */}
                </div>
                <DisplayToggle />
                {displayMode === 'table' ? <TableView /> : <CardView />}
              </>)}
            </CardBody>
          </Card>
        </Col>
        <Col md={6} className="ps-4 border-start">
          <Card className="shadow-sm h-100">
            <div className="card-header bg-light d-flex align-items-center justify-content-between py-3">
              <div className="d-flex align-items-center">
                <div className="position-relative me-2">
                  <FaShoppingCart size={18} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-6px',
                        right: '-10px',
                        fontSize: '0.65rem',
                        width: '16px',
                        height: '16px',
                        padding: 0
                      }}
                    >
                      {cart.length}
                    </Badge>
                  )}
                </div>
                <h6 className="mb-0 fw-bold me-3">{t('cart.title')}</h6> {/* Adjusted margin */}

              </div>
              {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleClearCart}
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </div>
            <CardBody className="p-0">

              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '150px',
                      opacity: '0.5',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <Card className="mb-3">
                    <CardBody className="p-0">
                      <div className="cart-container" style={{
                        height: '350px',
                        overflowY: 'auto',
                        fontSize: '0.9rem'
                      }}>
                        <Table hover responsive className="mb-0 cart-table">
                          <thead className="bg-light position-sticky top-0" style={{ zIndex: 1 }}>
                            <tr>
                              <th>{t('devis.article')}</th>
                              <th>{t('devis.quantite')}</th>
                              <th>{t('devis.unite')}</th>
                              <th>{t('devis.prixUnitaireTTC')}</th>
                              <th>{t('devis.montantTTC')}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentCartItems.map((item, index) => (
                              <tr key={item.id} className="align-middle">
                                <td style={{ maxWidth: '200px' }}>
                                  <Input
                                    type="text"
                                    name="articleNom"
                                    value={item.articleNom}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled
                                  />
                                </td>
                                <td style={{ width: '120px' }}>
                                  <div className="position-relative">
                                    <Input
                                      type="number"
                                      name="quantite"
                                      value={item.quantite}
                                      onChange={(event) => handleInputChange(index, event)}
                                      className="pe-4"
                                    />
                                    <FaKeyboard
                                      style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: showVirtualKeyboard && keyboardTarget === 'quantity' && currentEditingIndex === index ? '#007bff' : '#adb5bd',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                      }}
                                      title="Clavier numérique"
                                      onClick={() => openVirtualKeyboard('quantity', 'numeric', index)}
                                    />
                                  </div>
                                </td>
                                <td style={{ width: '100px' }}>
                                  <Input
                                    type="text"
                                    name="unite"
                                    value={unites.find(u => u.code === item.unite).libelle}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="number"
                                    name="prixUnitaireTTC"
                                    value={item.prixUnitaireTTC}
                                    onChange={(event) => handleInputChange(index, event)}
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="text"
                                    name="montantTTC"
                                    value={formatPrice(item.montantTTC, false)}
                                    disabled
                                  />
                                </td>
                                {/* <td>
                                  {item.appliedTaxRate * 100}%
                                </td> */}
                                <td style={{ width: '40px' }}>
                                  <Button
                                    color="link"
                                    className="p-0 text-danger"
                                    onClick={() => handleRemoveFromCart(item.articleId)}
                                  >
                                    <FaTrash size={12} />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="border-top p-3">
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="fs-5 fw-bold text-muted ps-2">
                          {t('cart.totalTTC')}
                        </div>
                        <div className="fs-4 fw-bold text-primary pe-2">
                          {formatPrice(montantTotalTTC)}
                        </div>
                      </div>
                    </>
                    <Button
                      color="success"
                      className="w-100 mt-3 py-2"
                      size="xl"
                      onClick={() => {
                        if (!cart.length) {
                          Swal.fire({
                            icon: 'warning',
                            title: t('cart.empty'),
                            text: t('cart.emptyMessage')
                          });
                          return;
                        }
                        setIsValidatingOrder(true);
                        setPaymentModal(true);
                      }}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('cart.checkout')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>

      </Row>
      {/* Receipt Modal */}
      {/* Order Preparation Ticket Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)} size="md">
        <ModalHeader toggle={() => setModal(false)} className="bg-primary text-white border-0 py-2">
          <div className="d-flex align-items-center">
            <FaReceipt className="me-2" size={18} />
            <span className="fw-bold">Bon de préparation</span>
          </div>
        </ModalHeader>
        <ModalBody className="p-3">
          <div id="preparation-ticket-content" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {/* Order Info */}
            <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
              <div>
                <small className="text-muted">Commande N°</small>
                <div className="fw-bold text-primary">{receiptData?.numero}</div>
              </div>
              <div>
                <small className="text-muted">Date</small>
                <div className="fw-bold">{new Date().toLocaleDateString('fr-MA')}</div>
              </div>
              <div>
                <small className="text-muted">Client</small>
                <div className="fw-bold">{selectedClient?.label || 'Client passager'}</div>
              </div>
            </div>

            {/* Products List */}
            <div className="preparation-items">
              <h6 className="fw-bold mb-2 text-primary">
                <FaBoxes className="me-2" size={16} />
                Articles à préparer ({receiptData?.lignes?.length || 0})
              </h6>

              <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                <table className="table table-sm table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Article</th>
                      <th className="text-center">Qté</th>
                      <th className="text-center">✓</th>
                    </tr>
                  </thead>
                  <tbody>
                    {receiptData && receiptData.lignes.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="fw-semibold">{item.articleNom}</div>
                          <small className="text-muted">{item.articleCode}</small>
                        </td>
                        <td className="text-center">
                          <Badge color="primary" className="px-2">
                            {item.quantiteLivree} {unites.find(u => item.unite === u.code)?.libelle}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`item-${index}`}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Summary */}
            <div className="mt-3 p-2 bg-light rounded">
              <div className="d-flex justify-content-between text-center">
                <div>
                  <small className="text-muted">Total articles</small>
                  <div className="fw-bold">
                    {receiptData?.lignes?.reduce((total, item) => total + parseFloat(item.quantiteLivree), 0) || 0}
                  </div>
                </div>
                <div>
                  <small className="text-muted">Préparé par</small>
                  <div className="fw-bold">{fullName}</div>
                </div>
                <div>
                  <small className="text-muted">Heure</small>
                  <div className="fw-bold">{new Date().toLocaleTimeString('fr-MA', { hour: '2-digit', minute: '2-digit' })}</div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="border-top py-2">
          <Button color="primary" size="sm" onClick={generatePreparationTicket} className="d-flex align-items-center">
            <FaPrint className="me-1" size={14} />
            Imprimer
          </Button>
          <Button color="secondary" size="sm" onClick={() => setModal(false)}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>


      {/* Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal} size="xl" className="payment-modal">
        <ModalHeader toggle={togglePaymentModal} className="bg-primary text-white border-0">
          <div className="d-flex align-items-center">
            <FaShoppingCart className="me-2" size={20} />
            <span className="fw-bold">{t('sale.confirmSale')}</span>
          </div>
        </ModalHeader>
        <ModalBody className="p-4">
          {/* Client Selection Section */}
          <div className="client-section mb-4">
            <div className="section-header mb-3">
              <h6 className="text-primary fw-bold mb-0 d-flex align-items-center">
                <FaUser className="me-2" />
                {t('commande.client')}
              </h6>
              {id && isValidatingOrder && (
                <small className="text-muted mt-1">
                  <FaInfoCircle className="me-1" />
                  Le client ne peut pas être modifié lors de l'édition d'un bon de livraison existant
                </small>
              )}
            </div>

            <Card className="border-0 bg-light">
              <CardBody className="p-3">
                <div className="d-flex gap-2 mb-3">
                  <div className="flex-grow-1">
                    <Select
                      id="clientId"
                      name="client"
                      isClearable
                      isDisabled={isPassager || (id && isValidatingOrder)}
                      placeholder={t('devis.selectClient')}
                      loadOptions={loadClientOptions}
                      onChange={handleSelectedClient}
                      defaultOptions={cachedOptions}
                      value={selectedClient ? {
                        value: selectedClient.value,
                        label: selectedClient.label
                      } : null}
                      className="react-select"
                      classNamePrefix="select"
                      noOptionsMessage={() => t('devis.noClientFound')}
                      loadingMessage={() => t('common.loading')}
                      components={{
                        DropdownIndicator: () => <FaUser className="me-2" />,
                        Option: ({ children, ...props }) => (
                          <components.Option {...props}>{children}</components.Option>
                        )
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? '#0d6efd' : '#ced4da',
                          boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
                          '&:hover': {
                            borderColor: '#0d6efd'
                          }
                        })
                      }}
                    />
                  </div>
                  <Button
                    color="primary"
                    onClick={handleCreateClient}
                    disabled={isPassager}
                    className="d-flex align-items-center justify-content-center"
                    style={{ minWidth: '40px' }}
                  >
                    <FaPlus />
                  </Button>
                </div>

                <div className="d-flex gap-4 align-items-center">
                  <div className="form-check d-flex align-items-center mb-0">
                    <Input
                      type="checkbox"
                      id="isPassager"
                      className="form-check-input"
                      checked={isPassager}
                      onChange={(e) => {
                        setIsPassager(e.target.checked);
                        if (e.target.checked) {
                          setSelectedClient(null);
                        }
                      }}
                    />
                    <Label check for="isPassager" className="form-check-label text-muted ms-2 mb-0">
                      <FaUserSecret className="me-1" />
                      {t('sale.clientPassager')}
                    </Label>
                  </div>
                  <div className="form-check d-flex align-items-center mb-0">
                    <Input
                      type="checkbox"
                      id="estCadeau"
                      className="form-check-input"
                      checked={estCadeau}
                      onChange={(e) => {
                        setEstCadeau(e.target.checked);
                      }}
                    />
                    <Label check for="estCadeau" className="form-check-label text-muted ms-2 mb-0">
                      <FaGift className="me-1" />
                      {t('sale.estCadeau')}
                    </Label>
                  </div>
                  <div className="form-check d-flex align-items-center mb-0">
                    <Input
                      type="checkbox"
                      id="estOnline"
                      className="form-check-input"
                      checked={estOnline}
                      onChange={(e) => {
                        setEstOnline(e.target.checked);
                      }}
                    />
                    <Label check for="estOnline" className="form-check-label text-muted ms-2 mb-0">
                      <FaGlobe className="me-1" />
                      {t('sale.estOnline')}
                    </Label>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>


        </ModalBody>

        <ModalFooter className="border-top-0 bg-light p-4">
          <div className="d-flex w-100 gap-2">
            <Button
              color="secondary"
              onClick={togglePaymentModal}
              className="flex-fill py-2 d-flex align-items-center justify-content-center"
            >
              <FaTimes className="me-2" />
              {t('payment.cancel')}
            </Button>
            <Button
              color="success"
              onClick={() => handleCreateSale(formik.values)}
              className="flex-fill py-2 d-flex align-items-center justify-content-center fw-bold"
              style={{ fontSize: '1.1rem' }}
            >
              <FaCheck className="me-2" />
              {t('payment.confirm')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>


      <Modal isOpen={clearCartModal} toggle={toggleClearCartModal} size="xl">
        <ModalHeader toggle={toggleClearCartModal}>
          {t('cart.clearConfirmTitle')}
        </ModalHeader>
        <ModalBody>
          {t('cart.clearConfirmMessage')}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleClearCart}>
            {t('cart.confirm')}
          </Button>
          <Button color="secondary" onClick={toggleClearCartModal}>
            {t('cart.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={clientModal} toggle={toggleClientModal}>
        <ModalHeader toggle={toggleClientModal}>
          {t('facture.client.selectClient')}
        </ModalHeader>
        <ModalBody>
          {showClientForm ? (
            <ClientForm
              onClientAdded={handleClientAdded}
              onCancel={() => setShowClientForm(false)}
            />
          ) : (
            <ListGroup>
              {clients.map((client) => (
                <ListGroupItem
                  key={client.id}
                  action
                  onClick={() => handleSelectClient(client)}
                >
                  {client.type === 'particulier' ? `${client.firstName} ${client.lastName}` : client.businessName}
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </ModalBody>
        <ModalFooter>
          {!showClientForm && (
            <Button color="primary" onClick={() => setShowClientForm(true)}>
              {t('facture.client.create')}
            </Button>
          )}
          <Button color="secondary" onClick={toggleClientModal}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showClientModal} toggle={() => setShowClientModal(false)} size="xl">
        <ModalHeader toggle={() => setShowClientModal(false)}>
          {t('client.newClient')}
        </ModalHeader>
        <ModalBody>
          <Card className="border-0 shadow-sm">
            <CardBody className="p-2">
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="typeClient" className="fw-bold">
                      <FaIdCard className="me-2 text-muted" />
                      Type de Client*
                    </Label>
                    <Input
                      type="select"
                      id="typeClient"
                      name="typeClient"
                      value={client.typeClient}
                      onChange={handleClientChange}
                      className="py-2"
                    >
                      <option value="PARTICULIER">Particulier</option>
                      <option value="ENTREPRISE">Entreprise</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {client.typeClient === 'PARTICULIER' &&
                <Row>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="nom" className="fw-bold">
                        <FaUser cclassName="me-2 text-muted" />
                        Nom*
                      </Label>
                      <Input
                        type="text"
                        id="nom"
                        name="nom"
                        value={client.nom}
                        onChange={handleClientChange}
                        invalid={!!clientErrors.nom}
                        placeholder="El Fassi"
                        className="py-2"
                      />
                      {clientErrors.nom && <div className="text-danger small mt-1">{clientErrors.nom}</div>}
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="prenom" className="fw-bold">
                        <FaUser className="me-2 text-muted" />
                        Prénom*
                      </Label>
                      <Input
                        type="text"
                        id="prenom"
                        name="prenom"
                        value={client.prenom}
                        onChange={handleClientChange}
                        invalid={!!clientErrors.prenom}
                        placeholder="Karim"
                        className="py-2"
                      />
                      {clientErrors.prenom && <div className="text-danger small mt-1">{clientErrors.prenom}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="cin" className="fw-bold">
                        <FaIdCard className="me-2 text-muted" />
                        CIN
                      </Label>
                      <Input
                        type="text"
                        id="cin"
                        name="cin"
                        value={client.cin}
                        onChange={handleClientChange}
                        placeholder="AB123456"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>

                </Row>}
              {client.typeClient === 'ENTREPRISE' &&
                <Row>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="entreprise" className="fw-bold">
                        <FaBuilding className="me-2 text-muted" />
                        Nom de l'entreprise
                      </Label>
                      <Input
                        type="text"
                        id="entreprise"
                        name="entreprise"
                        value={client.entreprise}
                        onChange={handleClientChange}
                        placeholder="Nom de l'entreprise"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="ice" className="fw-bold">
                        <FaIdCard className="me-2 text-muted" />
                        ICE
                      </Label>
                      <Input
                        type="text"
                        id="ice"
                        name="ice"
                        value={client.ice}
                        onChange={handleClientChange}
                        placeholder="Numéro ICE"
                        className="py-2"
                      />
                    </FormGroup>
                  </Col>
                </Row>}
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="telephone" className="fw-bold">
                      <FaPhone className="me-2 text-muted" />
                      Téléphone (1) *
                    </Label>
                    <Input
                      type="tel"
                      id="telephone1"
                      name="telephone1"
                      value={client.telephone1}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.telephone1}
                      placeholder="06 12 34 56 78"
                      className="py-2"
                    />
                    {clientErrors.telephone1 && <div className="text-danger small mt-1">{clientErrors.telephone1}</div>}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="telephone2" className="fw-bold">
                      <FaPhone className="me-2 text-muted" />
                      Téléphone (2) *
                    </Label>
                    <Input
                      type="tel"
                      id="telephone2"
                      name="telephone2"
                      value={client.telephone2}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.telephone2}
                      placeholder="06 12 34 56 78"
                      className="py-2"
                    />
                    {clientErrors.telephone2 && <div className="text-danger small mt-1">{clientErrors.telephone2}</div>}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="email" className="fw-bold">
                      <FaEnvelope className="me-2 text-muted" />
                      Email
                    </Label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={client.email}
                      onChange={handleClientChange}
                      placeholder="k.elfassi@example.com"
                      className="py-2"
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="ville" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Ville
                    </Label>
                    <Input
                      type="select"
                      id="ville"
                      name="ville"
                      value={client.ville}
                      onChange={handleClientChange}
                      className="py-2"
                    >
                      {villesMaroc.map(ville => (
                        <option key={ville} value={ville}>{ville}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="adresse" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Adresse*
                    </Label>
                    <Input
                      type="textarea"
                      rows="2"
                      id="adresse"
                      name="adresse"
                      value={clientErrors.adresse}
                      onChange={handleClientChange}
                      invalid={!!clientErrors.adresse}
                      placeholder="12 Rue Moulay Rachid"
                      className="py-2"
                    />
                    {clientErrors.adresse && <div className="text-danger small mt-1">{clientErrors.adresse}</div>}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-4">
                    <Label for="codePostal" className="fw-bold">
                      <FaMapMarkerAlt className="me-2 text-muted" />
                      Code Postal
                    </Label>
                    <Input
                      type="text"
                      id="codePostal"
                      name="codePostal"
                      value={client.codePostal}
                      onChange={handleClientChange}
                      placeholder="20000"
                      className="py-2"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmitClient}>
            {t('common.save')}
          </Button>
          <Button color="secondary" onClick={() => setShowClientModal(false)}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </Container >
  );
};

export default SaleForm;
